import script from "./Video.vue?vue&type=script&lang=ts&setup=true"
export * from "./Video.vue?vue&type=script&lang=ts&setup=true"

import "./Video.vue?vue&type=style&index=0&id=e3518bf4&lang=less"

const __exports__ = script;

export default __exports__